import { createStore } from 'effector';

export const $manufacturerData = createStore({name: '', manufacturers: []});

export const $manufacturerInfo = createStore({
  blocks: [],
  graphs: [],
});
